import { GameCategoryEnum, IFrameGameURLEnum, SportProvider } from '#lib/enums'

export const GAME_PROVIDERS: Record<string, string> = {
  jdb: 'jdb',
  yl: 'yl',
  ka: 'ka',
  tp: 'tp',
  bbin2: 'bbin2',
  fastspin: 'fastspin',
  funta: 'funta',
  od_gaming: 'od_gaming',
  ps: 'ps',
  rsg: 'rsg',
  yesbingo: 'yesbingo',
  rich88: 'rich88',
  acewin: 'acewin',
  playson: 'playson',
  slotopia: 'slotopia',
  spadegaming: 'spadegaming',
  spade_gaming: 'spade_gaming',
  yeebet: 'yeebet',
  zenith_microgaming: 'zenith_microgaming',
  winfinity: 'winfinity',
  bng: 'bng',
  yellow_bat: 'yellow_bat',
  relax_gaming: 'relax_gaming',
  hacksaw: 'hacksaw',
  advantplay: 'advantplay',
  iloveyou: 'iloveyou',
  fachai: 'fachai',
  jili: 'jili',
  evolution_netent: 'evolution_netent',
  spinix: 'spinix',
  techplay: 'techplay',
  nextspin: 'nextspin',
  pragmatic: 'pragmatic',
  pgsoft: 'pgsoft',
  yesgetrich: 'yesgetrich',
  cq9: 'cq9',
  redtiger: 'redtiger',
  playngo: 'playngo',
  asiagaming: 'asiagaming',
  gameplay: 'gameplay',
  dragongaming: 'dragongaming',
  bgaming: 'bgaming',
  habanero: 'habanero',
  spribe: 'spribe',
  ezugi: 'ezugi',
  im: 'im',
  ebet: 'ebet',
  dream_gaming: 'dream_gaming',
  sa_gaming: 'sa_gaming',
  'evolution-gaming': 'evolution-gaming',
}

export const ATHENA_GAMES = [
  {
    name: 'c-sports',
    id: 'play-sport-game',
  },
  {
    name: 'E sports',
    id: 'esports',
  },
  {
    name: 'Virtual sport',
    id: 'vsport',
  },
  {
    name: 'keno',
    id: 'keno',
  },
  {
    name: 'TP Number game',
    id: 'tp-numbergame',
  },
  {
    name: 'number-game',
    id: 'number-game',
  },
  {
    name: 'virtual games',
    id: 'virtualgame',
  },
  {
    name: 'Saba club',
    id: 'saba-club',
  },
  {
    name: 'lottery-cyber-punk',
    id: 'lottery-cyber-punk',
  },
  {
    name: 'Quay so Disco',
    id: 'quayso-disco',
  },
  {
    name: 'v-gaming',
    id: '58239',
  },
  {
    name: 'numbers game saba',
    id: '32751',
  },
  {
    name: 'keno Saba',
    id: '57270',
  },
  {
    name: 'parlay 5',
    id: '57452',
  },
  {
    name: 'turbo',
    id: '57450',
  },
  {
    name: 'soccer',
    id: '57448',
  },
  {
    name: 'happy 5',
    id: '57446',
  },
  {
    name: 'Saba Table Games',
    id: 'tablegame',
  },
  {
    name: 'lottery',
    id: '57277',
  },
]

export const ROLLING_WHEN_USING_100K_PROMOTION = 400

export const LOBBY_GAME_URLS = {
  HOME: '/',
  SPORTS: '/the-thao',
  CASINO: '/live-casino',
  ALL_GAME: '/lobby-game',
  INSTANT_GAMES: `/lobby-game?type=${GameCategoryEnum.INSTANT_GAMES}`,
  SLOT: `/lobby-game?type=${GameCategoryEnum.SLOTS}`,
  FISHING: `/lobby-game?type=${GameCategoryEnum.FISHING}`,
  LODE: `/lobby-game?type=${GameCategoryEnum.LO_DE}`,
  LOTTERY: `/lobby-game?type=${GameCategoryEnum.QUAY_SO}`,
  QUICKGAME: `/lobby-game?type=${GameCategoryEnum.DAU_TRI}`,
  INGAME: `/lobby-game?type=${GameCategoryEnum.IN_GAME}`,
  TABLE_GAMES: `/lobby-game?type=${GameCategoryEnum.TABLE_GAMES}`,
  NO_HU: `/lobby-game?type=${GameCategoryEnum.NO_HU}`,
  GAME_BAI: `/lobby-game?type=${GameCategoryEnum.CARD_GAME}`,
  BATTLE_GAMES: `/lobby-game?type=${GameCategoryEnum.BATTLE_GAMES}`,
  OTHERS: `/lobby-game?type=${GameCategoryEnum.OTHER}`,
}

export const ULR_LOBBY_IFRAME_GAMES = [
  '/lo-de-sieu-toc',
  '/lo-de-3-mien',
  '/lo-de-dai-cat',
  '/quayso-disco',
  '/tp-keno',
  '/lottery-cyber-punk',
]

export const IFRAME_GAME_API: Record<string, string> = {
  VIRTUAL_SPORTS: `games/play?provider=${SportProvider.V_SPORTS}`,
  ESPORTS: `games/play?provider=${SportProvider.E_SPORTS}`,
  LIVE_CASINO: 'games/casinoUrl',
  VIRTUAL_GAME: 'games/play?gameType=virtual-game',
  SABA_CLUB: 'games/play?gameType=saba-club',
  NUMBER_GAME: 'games/play?gameType=number-game',
  TABLE_GAMES: 'games/play?gameType=table-game',
  KENO: 'games/play?gameType=keno',
  LOTTERY: 'games/play?gameType=lottery',
  VIRTUAL_CASINO: 'games/play?gameType=virtual-casino',
  V_GAMING: 'games/play?gameType=v-gaming',
  C_SPORTS: `games/play?provider=${SportProvider.C_SPORTS}`,
  I_SPORTS: `games/play?provider=${SportProvider.I_SPORTS}`,
  M_SPORTS: `games/play?provider=${SportProvider.M_SPORTS}`,
  K_SPORTS: `games/play?provider=${SportProvider.K_SPORTS}`,
  P_SPORTS: `games/play?provider=${SportProvider.P_SPORTS}`,
  KENO_VIETLOT: 'games/url?gameName=keno-vietlott',
  QUAYSO_ATOM: 'games/url?gameName=quayso-atom',
  NUMBER_GAME_5_URL: 'games/url?gameName=number-game-5'
}

export const IFRAME_GAME_API_MAP: Record<IFrameGameURLEnum, string> = {
  [IFrameGameURLEnum.VIRTUAL_SPORTS]: IFRAME_GAME_API.VIRTUAL_SPORTS,
  [IFrameGameURLEnum.ESPORTS]: IFRAME_GAME_API.ESPORTS,
  [IFrameGameURLEnum.LIVE_CASINO]: IFRAME_GAME_API.LIVE_CASINO,
  [IFrameGameURLEnum.VIRTUAL_GAME]: IFRAME_GAME_API.VIRTUAL_GAME,
  [IFrameGameURLEnum.TABLE_GAMES]: IFRAME_GAME_API.TABLE_GAMES,
  [IFrameGameURLEnum.SABA_CLUB]: IFRAME_GAME_API.SABA_CLUB,
  [IFrameGameURLEnum.NUMBER_GAME]: IFRAME_GAME_API.NUMBER_GAME,
  [IFrameGameURLEnum.KENO]: IFRAME_GAME_API.KENO,
  [IFrameGameURLEnum.LOTTERY]: IFRAME_GAME_API.LOTTERY,
  [IFrameGameURLEnum.C_SPORTS]: IFRAME_GAME_API.C_SPORTS,
  [IFrameGameURLEnum.P_SPORTS]: IFRAME_GAME_API.P_SPORTS,
  [IFrameGameURLEnum.I_SPORTS]: IFRAME_GAME_API.I_SPORTS,
  [IFrameGameURLEnum.M_SPORTS]: IFRAME_GAME_API.M_SPORTS,
  [IFrameGameURLEnum.K_SPORTS]: IFRAME_GAME_API.K_SPORTS,
  [IFrameGameURLEnum.V_GAMING]: IFRAME_GAME_API.V_GAMING,
  [IFrameGameURLEnum.TP_NUMBER_GAME]: '',
  [IFrameGameURLEnum.TP_KENO]: '',
  [IFrameGameURLEnum.LOTTERY_LAS_VEGAS]: '',
  [IFrameGameURLEnum.LOTTERY_CYBER_PUNK]: '',
  [IFrameGameURLEnum.LODE]: '',
  [IFrameGameURLEnum.LODE_SIEUTOC]: '',
  [IFrameGameURLEnum.LODE_DAICAT]: '',
  [IFrameGameURLEnum.LODE_AO]: '',
  [IFrameGameURLEnum.VIRTUAL_CASINO]: '',
  [IFrameGameURLEnum.T_SPORTS]: '',
  [IFrameGameURLEnum.KENO_VIETLOT]: '',
  [IFrameGameURLEnum.QUAYSO_ATOM]: '',
  [IFrameGameURLEnum.NUMBER_GAME_5_URL]: '',
}

const heightValueSport = '916px'
const heightValueLoDe = '885px'
const heightValueKeno = '1921px'
const heightValueLottery = '768px'

export const MAPPING_IFRAME_GAMES = {
  [IFrameGameURLEnum.VIRTUAL_SPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.ESPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.LIVE_CASINO]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.VIRTUAL_GAME]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.TABLE_GAMES]: {
    height: heightValueLoDe,
  },
  [IFrameGameURLEnum.LODE]: {
    height: heightValueLoDe,
  },
  [IFrameGameURLEnum.LODE_SIEUTOC]: {
    height: heightValueLoDe,
  },
  [IFrameGameURLEnum.LODE_DAICAT]: {
    height: heightValueLoDe,
  },
  [IFrameGameURLEnum.V_GAMING]: {
    height: heightValueLoDe,
  },
  [IFrameGameURLEnum.NUMBER_GAME]: {
    height: '950px',
  },
  [IFrameGameURLEnum.TP_NUMBER_GAME]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.KENO]: {
    height: heightValueKeno,
  },
  [IFrameGameURLEnum.TP_KENO]: {
    height: heightValueKeno,
  },
  [IFrameGameURLEnum.LOTTERY_LAS_VEGAS]: {
    height: heightValueLottery,
  },
  [IFrameGameURLEnum.LOTTERY_CYBER_PUNK]: {
    height: heightValueLottery,
  },
  [IFrameGameURLEnum.LOTTERY]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.C_SPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.M_SPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.P_SPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.K_SPORTS]: {
    height: heightValueSport,
  },
  [IFrameGameURLEnum.VIRTUAL_CASINO]: {
    height: heightValueSport,
  },
  [`${IFrameGameURLEnum.NUMBER_GAME}?sportId=164`]: {
    height: heightValueSport,
  },
  [`${IFrameGameURLEnum.NUMBER_GAME}?sportId=161`]: {
    height: heightValueSport,
  },
  [`${IFrameGameURLEnum.NUMBER_GAME}?sportId=soccerlottery`]: {
    height: heightValueSport,
  },
}
